<template>
  <div am-edit-modal-item am-select-item>
    <i-dropdown placement="bottom-start">
      <div class="_display:flex _align-items:center" am-select-show>
        <p class="_margin:0">{{ data.data }}</p>
        <i-icon name="ink-caret-down" />
      </div>
      <template #body>
        <i-dropdown-item
          v-for="option in data.possible"
          :key="option"
          :disabled="option === data.data"
          @click.prevent="select(option)"
        >
          {{ option }}
        </i-dropdown-item>
      </template>
    </i-dropdown>
  </div>
</template>

<script>
import { mapMutations } from 'vuex'

export default {
  name: 'SelectItem',
  props: {
    data: {
      type: Object,
      required: true
    }
  },
  methods: {
    ...mapMutations('parts', ['SET_CHANGED_PARTS']),
    select (value) {
      this.$store.state.parts.data[this.$route.params.subtable].parts[this.data.index].data = value
      this.SET_CHANGED_PARTS({ subtable: this.$route.params.subtable, data: this.data })
    }
  }
}
</script>

<style lang="scss">
[am-select-item] {
  [am-select-show] {
    cursor: pointer;
  }
}
</style>
